import React, { useEffect, useRef, useState } from 'react';

const checkIcon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>;
const shieldIcon = <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;

const tabs = [
  { key: 'description', label: 'Description', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> },
  { key: 'keyfeatures', label: 'Key Features', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg> },
  { key: 'highlights', label: 'Highlights', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 11V7a4 4 0 1 1 8 0v4"/><path d="M20 17a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4z"/></svg> },
  { key: 'specs', label: 'Specifications', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg> },
  { key: 'benefits', label: 'Benefits', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg> },
  { key: 'whychoose', label: 'Why Choose Us', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg> },
  { key: 'package', label: 'Package Included', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg> },
];

const listData = {
  keyfeatures: { label: 'Key Features', icon: checkIcon, color: 'bg-brand/15 text-brand', items: (p) => p.features?.length ? p.features : ['High Conductivity', 'Shock Resistant', 'Heat Resistant', 'Easy Installation', 'Long Life', 'ISI Standard'] },
  benefits: { label: 'Product Benefits', icon: checkIcon, color: 'bg-green-500/15 text-green-400', items: (p) => p.benefits?.length ? p.benefits : ['Enhanced home safety', 'Lower electricity bills', 'Longer lifespan', 'Zero maintenance', 'Consistent performance'] },
  whychoose: { label: 'Why Choose FACTO', icon: shieldIcon, color: 'bg-brand/15 text-brand', items: (p) => p.why_choose_us?.length ? p.why_choose_us : ['5 Year Warranty', 'Pan India Service', 'Premium Materials', 'Affordable Pricing'] },
  package: { label: 'Package Included', icon: checkIcon, color: 'bg-green-500/15 text-green-400', items: (p) => p.package_included?.length ? p.package_included : ['FACTO Wire Roll', 'Warranty Card', 'User Manual', 'Inspection Certificate'] },
};

const ProductTabs = ({ product }) => {
  const [active, setActive] = useState('description');
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const contentRef = useRef(null);
  const activeTab = tabs.find((t) => t.key === active) || tabs[0];

  const handleTabChange = (key) => {
    setActive(key);
    setOpen(false);
    setTimeout(() => {
      contentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const renderContent = () => {
    if (active === 'description') {
      return (
        <div className="max-w-3xl">
          <h2 className="text-lg font-bold text-white md:text-xl">Product Description</h2>
          <div className="mt-3 space-y-3 text-sm leading-7 text-muted">
            <p>{product.description || 'This premium FACTO Electrical product is engineered with advanced technology to deliver safe, reliable and long-lasting performance for all your electrical needs.'}</p>
            <p>Manufactured with high-quality materials and rigorously tested to meet the highest industry standards, this product ensures safety, durability and consistent performance in every application.</p>
          </div>
          <h2 className="mt-6 text-lg font-bold text-white md:text-xl">Key Features</h2>
          <div className="mt-3 flex flex-wrap gap-2">
            {(product.features?.length ? product.features : ['99.97% Pure Copper', 'Triple Layer FR PVC', 'High Conductivity', 'Shock Resistant', 'Heat Resistant', 'Easy Installation', 'Long Life', 'ISI Standard']).map((f, i) => (
              <span key={i} className="flex items-center gap-2 rounded-full border border-line bg-card px-4 py-2 text-xs font-medium text-white transition-colors duration-250 hover:border-brand/40">
                <span className="text-brand">{checkIcon}</span>
                {f}
              </span>
            ))}
          </div>
        </div>
      );
    }

    if (active === 'highlights') {
      const items = product.highlights?.length ? product.highlights : ['Premium Build Quality', 'Superior Performance', 'Certified Safety', 'Trusted Brand'];
      return (
        <div className="max-w-3xl">
          <h2 className="text-lg font-bold text-white md:text-xl">Product Highlights</h2>
          <div className="mt-3 flex flex-wrap gap-2">
            {items.map((h, i) => (
              <span key={i} className="rounded-full border border-brand/40 bg-brand/10 px-5 py-2.5 text-sm font-medium text-brand">{h}</span>
            ))}
          </div>
        </div>
      );
    }

    if (active === 'specs') {
      const specRows = product.specs && typeof product.specs === 'object' && Object.keys(product.specs).length > 0
        ? Object.entries(product.specs).map(([k, v]) => [k, typeof v === 'object' ? JSON.stringify(v) : String(v)])
        : [['Product Type', 'FR PVC Flexible Wire'], ['Brand', product.brand || 'FACTO'], ['Conductor', '99.97% Pure Copper'], ['Length', '90 Meter'], ['Voltage', '1100V'], ['Temperature', 'Up to 70°C'], ['Warranty', '3 Years'], ['Standards', 'ISI Certified']];
      return (
        <div className="w-full max-w-3xl">
          <h2 className="text-lg font-bold text-white md:text-xl">Technical Specifications</h2>
          <div className="mt-3 overflow-x-auto rounded-xl border border-line">
            <table className="w-full min-w-[300px] text-sm">
              <tbody className="divide-y divide-line">
                {specRows.map(([k, v]) => (
                  <tr key={k} className="bg-[#0B1220]">
                    <td className="whitespace-nowrap px-3 py-2.5 text-muted md:px-4 md:py-3">{k}</td>
                    <td className="whitespace-nowrap px-3 py-2.5 font-medium text-white md:px-4 md:py-3">{v}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      );
    }

    const cfg = listData[active];
    const items = cfg.items(product);
    return (
      <div className="max-w-3xl">
        <h2 className="text-lg font-bold text-white md:text-xl">{cfg.label}</h2>
        <div className="mt-3 grid gap-2.5 sm:grid-cols-2">
          {items.map((item, i) => (
            <div key={i} className="flex items-center gap-3 rounded-xl border border-line bg-card px-4 py-3">
              <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${cfg.color}`}>{cfg.icon}</span>
              <span className="text-sm text-white">{item}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="my-8 md:my-10">
      {/* Desktop tab pills (hidden on mobile) */}
      <div className="hidden flex-wrap gap-2 md:flex">
        {tabs.map((t) => {
          const isActive = active === t.key;
          return (
            <button
              key={t.key}
              onClick={() => handleTabChange(t.key)}
              className={`relative shrink-0 overflow-hidden rounded-full px-4 py-2 text-[13px] font-medium transition-all duration-250 ${
                isActive
                  ? 'bg-brand text-black shadow-lg shadow-brand/25'
                  : 'border border-line bg-card text-muted hover:border-brand/40 hover:text-white'
              }`}
            >
              {isActive && <span className="absolute inset-0 -z-0 animate-pulse-slow rounded-full bg-brand/20" />}
              <span className="relative z-10">{t.label}</span>
            </button>
          );
        })}
      </div>

      {/* Mobile tab dropdown selector (hidden on desktop) */}
      <div ref={dropdownRef} className="relative mt-8 max-w-3xl md:hidden md:mt-0">
        <button
          onClick={() => setOpen(!open)}
          className="flex w-full items-center justify-between gap-3 rounded-xl border border-brand/40 bg-card px-4 py-3 text-sm font-semibold text-white transition-colors duration-250 hover:border-brand"
        >
          <span className="flex items-center gap-2">
            <span className="text-brand">{activeTab.icon}</span>
            {activeTab.label}
          </span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`text-muted transition-transform duration-250 ${open ? 'rotate-180' : ''}`}>
            <polyline points="6 9 12 15 18 9"/>
          </svg>
        </button>

        {open && (
          <div className="absolute z-40 mt-2 w-full overflow-hidden rounded-xl border border-line bg-card shadow-2xl shadow-black/50 animate-fade-in">
            {tabs.map((t) => (
              <button
                key={t.key}
                onClick={() => handleTabChange(t.key)}
                className={`flex w-full items-center gap-3 px-4 py-3 text-sm font-medium transition-colors duration-150 ${
                  active === t.key ? 'bg-brand/10 text-brand' : 'text-muted hover:bg-white/5 hover:text-white'
                }`}
              >
                <span className={active === t.key ? 'text-brand' : 'text-muted'}>{t.icon}</span>
                {t.label}
                {active === t.key && (
                  <svg className="ml-auto" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                )}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Animated content panel */}
      <div ref={contentRef} key={active} className="mt-8 animate-fade-in rounded-2xl border border-line bg-card/50 p-4 md:p-8">        {renderContent()}
      </div>
    </div>
  );
};

export default ProductTabs;
